import { render, staticRenderFns } from "./CustomerAddressWidget.vue?vue&type=template&id=26a6da5e&"
import script from "./CustomerAddressWidget.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports